
$(document).ready(function() {
/* bundle popup quanity box*/
var j = jQuery; 
var addInput = '#cust_Quantity'; 
var n = 1; 
j(addInput).val(n);
j('.custom_new_quantity .plus').on('click', function(){
 j(addInput).val(++n);
var GETplus = $(this).prev("#cust_Quantity").val();
//console.log("GETplus " + GETplus);
 $(".cust_bundle_qty").text(GETplus);
})

j('.custom_new_quantity .min').on('click', function(){
  if (n > 1) {
  j(addInput).val(--n);
  var GEtmin = $(this).next("#cust_Quantity").val();
  //console.log("GEtmin " + GEtmin);
   $(".cust_bundle_qty").text(GEtmin);
  } 
});
/* end bundle popup quanity box*/



 $('ul.tabs').each(function(){
 var active, content, links = $(this).find('a');
 active = links.first().addClass('active');
 content = $(active.attr('href'));
 links.not(':first').each(function () {
 $($(this).attr('href')).hide();
 });
 $(this).find('a').click(function(e){
 active.removeClass('active');
 content.hide();
 active = $(this);
 content = $($(this).attr('href'));
 active.addClass('active');
 content.show();
 return false;
 });
 });
  
  
 var pageURl = window.location.pathname;
  console.log("pageURl " + pageURl);
 var TEStURL = pageURl.split( '/' )[2];

  console.log("TEStURL " + TEStURL);
 last = pageURl.split("/")
 var GEtFinalURL = last[last.length-1];
 //console.log("GEtFinalURL " + GEtFinalURL);
  var count= 1;
  var abc;
  var IDs = [];

  var finalTitles =[];

    console.log("IDs " + IDs);
  
   $(".cust_four_pro").each(function(){
   // $(this).children(".product-tile").addClass("ssss");
    
     $(this).children(".product-tile").children('.outer_addToCArt').children(".col-add-to-btn1 ").children(".flex").children("form").children(".collection-size").change(function(){
      var getVarientID = (this.value);
  
      console.log("getVarientID " + getVarientID);
       
       $(this).parent("form").parent(".flex").parent(".col-add-to-btn1").next(".cust_inventory").next(".cust_Main_proID").text(getVarientID);
     
       var getInventory = $(this).children('option:selected').attr("inventory");
       console.log("getInventory " + getInventory); 
       $(this).parent("form").parent(".flex").parent(".col-add-to-btn1").next(".cust_inventory").text(getInventory);
       if(getInventory == 0){
         $(this).parent("form").parent(".flex").parent(".col-add-to-btn1").next(".cust_inventory").next(".cust_Main_proID").next(".cust_cart_btn").addClass("disabled");
         $(this).parent("form").parent(".flex").parent(".col-add-to-btn1").next(".cust_inventory").next(".cust_Main_proID").next(".cust_cart_btn").text("Sold Out");
       }
      else{
      $(this).parent("form").parent(".flex").parent(".col-add-to-btn1").next(".cust_inventory").next(".cust_Main_proID").next(".cust_cart_btn").removeClass("disabled");
     $(this).parent("form").parent(".flex").parent(".col-add-to-btn1").next(".cust_inventory").next(".cust_Main_proID").next(".cust_cart_btn").text("Add to Cart");
      }
      }); 
   }); 
     

   $('body').on('click', '.cust_cart_btn', function(){
     
     $(".cust-count-div").css("display", "block");
     
     var numItems = $('.cust_pop_info').length+1;
     
     var GetHandle = $(this).prev(".cust_Main_proID").attr("data-title");
     // console.log("GetHandle "+ GetHandle);
     // finalTitles.push(GetHandle);
     var GetPrice = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1 ").children(".flex").children("form").next(".mh2").next(".custom-price").children(".money").text();
     //console.log("GetPrice " + GetPrice);
     
     var GetTitle = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("title");
     //console.log("GetTitle "+ GetTitle);
     // finalTitles.push(GetTitle);
     
     var GEtImage= $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").prev(".product-tile__image-wrapper").children(".collection-product-img").children("a").children(".product-tile__sizer").children(".responsive-image__wrapper").children(".responsive-image__image").attr("src");
    //console.log("GEtImage " + GEtImage);

  
     /** pocket-square-poceket-squar conditions **/
     // if(GEtFinalURL == "pocket-square-pocket-square"){
      if (TEStURL == "pocket-square-pocket-square") {
     
      console.log("GEtFinalURL " +GEtFinalURL);
      if(numItems <= 2){
      $(".CUStom_count").append("<li>" + (count++) +"</li>")
      $(this).text('Remove');
      $(this).addClass('remove_text');
      $(this).removeClass('cust_cart_btn');
        
      var getID= $(this).prev(".cust_Main_proID").text();
       //console.log("getID "+ getID);
      var abc= IDs.push(getID);
      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "</div>" );
      }
      else{
      alert("You can not add more then Two products.");
      } 
      }
    /** end pocket-square-poceket-squar conditions **/
 
    if( TEStURL == "pocket-square-ties" || TEStURL == "pocket-square-stoles" || TEStURL == "stole-tie"){
    if(numItems <= 2){
    $(".CUStom_count").append("<li>" + (count++) +"</li>")
    $(this).text('Remove');
    $(this).addClass('remove_text');
    $(this).removeClass('cust_cart_btn');

    var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
    if(finalTitles.indexOf(GeTTAg)!= -1 ){
      $(this).removeClass('remove_text');
      $(this).addClass("cust_cart_btn");
      $(this).text('Add to Cart');
    alert("Product of same category already selected."); 
    } 
  else{
     var getID= $(this).prev(".cust_Main_proID").text();
     // console.log("getID "+ getID);
      var abc= IDs.push(getID);
    
     var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      console.log("GeTTAg " + GeTTAg);
     finalTitles.push(GeTTAg);
  //console.log("finalTitles " + finalTitles);
      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
      // alert("Value does not exists!")
      }
    }
    else{
    alert("You can not add more then Two products.");
    }
    }


 if(TEStURL == "pocket-squares-tie-cufflinks"  || TEStURL == "pocket-square-stole-cufflinks" || TEStURL == "stoles-ties-cufflinks"){
  if(numItems <= 3){
    $(".CUStom_count").append("<li>" + (count++) +"</li>")
    $(this).text('Remove');
    $(this).addClass('remove_text');
    $(this).removeClass('cust_cart_btn');
    
    var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
    if(finalTitles.indexOf(GeTTAg)!= -1 ){
      $(this).removeClass('remove_text');
      $(this).addClass("cust_cart_btn");
      $(this).text('Add to Cart');
     alert("Product of same category already selected.");
    } 
    else{
    var getID= $(this).prev(".cust_Main_proID").text();
    // console.log("getID "+ getID);
    var abc= IDs.push(getID);
    
    var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
   // console.log("GeTTAg " + GeTTAg);
    finalTitles.push(GeTTAg);
    
    $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
     //alert("Value does not exists!")
    }
    }
  else{
   alert("You can not add more then Three products.");
  }
}         

     
if(TEStURL == "pocket-square-ties-cravat-cufflinks" || TEStURL == "pocket-square-ties-stoles-cufflinks"){
  
  if(numItems <= 4){
    $(".CUStom_count").append("<li>" + (count++) +"</li>")
    $(this).text('Remove');
    $(this).addClass('remove_text');
    $(this).removeClass('cust_cart_btn');
     
   var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
    if(finalTitles.indexOf(GeTTAg)!= -1 ){
    $(this).removeClass('remove_text');
      $(this).addClass("cust_cart_btn");
       $(this).text('Add to Cart');
     alert("Product of same category already selected.");
    } 

  else{
      var getID= $(this).prev(".cust_Main_proID").text();
      // console.log("getID "+ getID);
      var abc= IDs.push(getID);
    
     // console.log("IDs "+ IDs);
    
      var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      //console.log("GeTTAg " + GeTTAg);
      finalTitles.push(GeTTAg);

      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
     // alert("Value does not exists!")
      }
    }
    else{
    alert("You can not add more then Four products.");
    }
    }

/* pocket-squares-pocket-squares-cufflinks  */
if(TEStURL == "pocket-square-pocket-square-cufflinks"){

$(".CUStom_count").append("<li>" + (count++) +"</li>")
    
var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
//console.log("GeTTAg " + GeTTAg);


  if(numItems <= 3){
  var countPocket = finalTitles.indexOf('Pocket');
  console.log("countPocket " + countPocket);
  $(".CUStom_count").append("<li>" + (count++) +"</li>")
    $(this).text('Remove');
    $(this).addClass('remove_text');
    $(this).removeClass('cust_cart_btn');
    
     var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      if(finalTitles.indexOf(GeTTAg)!= -1  ){
     
        $(this).removeClass('remove_text');
        $(this).addClass("cust_cart_btn");
        $(this).text('Add to Cart');
         if( GeTTAg == "Cufflinks"){
          alert("Product of same category already selected.");
         }

        const map = finalTitles.reduce((acc, e) => acc.set(e, (acc.get(e) || 0) + 1), new Map());
        console.log("map " + map);
      
       if(GeTTAg == "Pocket Square"){
       var GetMApVal = [...map.values("Pocket")]
       //alert("GetMApVal " + GetMApVal);
       
        if(GetMApVal > 1){
        alert("Product of same category already selected.");
        }
       // else {alert("not contain");}
       
        // else if(GetMApVal.indexOf(2) != -1){
        // alert("Product of same category already selected.");
        // }
      //  else{alert("not contain aaaa");}
        }
      if(finalTitles.length <= 1 && finalTitles.indexOf('Pocket Square')!= -1 ){
        $(this).text('Remove');
        $(this).addClass('remove_text');
        $(this).removeClass('cust_cart_btn');

        var getID= $(this).prev(".cust_Main_proID").text();
       // console.log("getID "+ getID);
        var abc= IDs.push(getID);
      
        var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
       // console.log("GeTTAg " + GeTTAg);
        finalTitles.push(GeTTAg);
    
        $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
      
         }
        if(finalTitles.indexOf('Cufflinks')!= -1 && finalTitles.indexOf('Pocket Square')!= -1 && GeTTAg == "Pocket Square"){  
        $(this).text('Remove');
        $(this).addClass('remove_text');
        $(this).removeClass('cust_cart_btn');
          
        var getID= $(this).prev(".cust_Main_proID").text();
        // console.log("getID "+ getID);
        var abc= IDs.push(getID);
    
        var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      //console.log("GeTTAg " + GeTTAg);
        finalTitles.push(GeTTAg);
         $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
       }
    }
    else{
      
      var getID= $(this).prev(".cust_Main_proID").text();
     // console.log("getID "+ getID);
      var abc= IDs.push(getID);
    
      var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
     // console.log("GeTTAg " + GeTTAg);
       finalTitles.push(GeTTAg);

      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
    // alert("not contain!");
     
      } 
   } else{
    alert("You can not add more then Three products.");
    }
 }
/* end pocket-squares-pocket-squares-cufflinks  */

/*pocket-squares-pocket-squares-stoles-cufflinks*/   
if(GEtFinalURL == "pocket-square-pocket-square-stole-cufflinks"){
 $(".CUStom_count").append("<li>" + (count++) +"</li>")
    $(this).text('Remove');
    $(this).addClass('remove_text');
    $(this).removeClass('cust_cart_btn');


   var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
   console.log("GeTTAg " + GeTTAg);
  
    
  
     console.log("finalTitles " + finalTitles);
     if(numItems <= 4){
      var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      if(finalTitles.indexOf(GeTTAg)!= -1  ){
        
        $(this).removeClass('remove_text');
        $(this).addClass("cust_cart_btn");
        $(this).text('Add to Cart');
        
        if(GeTTAg == "Stole" || GeTTAg == "Cufflinks"){
        alert("Product of same category already selected.");
        }
    
       const map = finalTitles.reduce((acc, e) => acc.set(e, (acc.get(e) || 0) + 1), new Map());
        console.log("map " + map);
      
       if(GeTTAg == "Pocket Square"){
       var GetMApVal = [...map.values("Pocket")]
       //alert("GetMApVal " + GetMApVal);
       
        if(GetMApVal > 1){
        alert("Product of same category already selected.");
        }
       // else {alert("not contain");}
       
        else if(GetMApVal.indexOf(2) != -1){
        alert("Product of same category already selected.");
        }
      //  else{alert("not contain aaaa");}
        }
      if(finalTitles.length <= 1 && finalTitles.indexOf('Pocket Square')!= -1 ){
         
          $(this).text('Remove');
          $(this).addClass('remove_text');
          $(this).removeClass('cust_cart_btn');

        var getID= $(this).prev(".cust_Main_proID").text();
       // console.log("getID "+ getID);
        var abc= IDs.push(getID);
      
        var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
        console.log("GeTTAg " + GeTTAg);
        finalTitles.push(GeTTAg);
    
        $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
         //alert("ssadasdsad");
         }
      if(finalTitles.indexOf('Stole')!= -1 && finalTitles.indexOf('Cufflinks')!= -1 && finalTitles.indexOf('Pocket Square')!= -1 && numItems <=4 && GeTTAg == "Pocket Square"){
        $(this).text('Remove');
        $(this).addClass('remove_text');
        $(this).removeClass('cust_cart_btn');
           
        var getID= $(this).prev(".cust_Main_proID").text();
       // console.log("getID "+ getID);
        var abc= IDs.push(getID);
    
        var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
        console.log("GeTTAg " + GeTTAg);
        finalTitles.push(GeTTAg);

      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
      //alert("amar!1");
        }
      if(finalTitles.indexOf('Stole')!= -1 && finalTitles.indexOf('Pocket Square')!= -1 && numItems <=3 && GeTTAg == "Pocket Square"){
        $(this).text('Remove');
        $(this).addClass('remove_text');
        $(this).removeClass('cust_cart_btn');
        
        var getID= $(this).prev(".cust_Main_proID").text();
     // console.log("getID "+ getID);
      var abc= IDs.push(getID);
    
      var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      console.log("GeTTAg " + GeTTAg);
       finalTitles.push(GeTTAg);

      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
      //alert("amar! 2");
        }
     if(finalTitles.indexOf('Cufflinks')!= -1 && finalTitles.indexOf('Pocket Square')!= -1 && numItems <=3 && GeTTAg == "Pocket Square" && GeTTAg == "Pocket Square"){
      $(this).text('Remove');
      $(this).addClass('remove_text');
      $(this).removeClass('cust_cart_btn');
       
      var getID= $(this).prev(".cust_Main_proID").text();
     // console.log("getID "+ getID);
      var abc= IDs.push(getID);
    
      var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      console.log("GeTTAg " + GeTTAg);
      finalTitles.push(GeTTAg);

      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
      //alert("amar!3 ");
        }
      }
     else{
       var getID= $(this).prev(".cust_Main_proID").text();
     // console.log("getID "+ getID);
      var abc= IDs.push(getID);
    
      var GeTTAg = $(this).prev(".cust_Main_proID").prev(".cust_inventory").prev(".col-add-to-btn1").parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
      console.log("GeTTAg " + GeTTAg);
       finalTitles.push(GeTTAg);

      $(".cust-count ").append("<div class='cust_pop_info'>" + '<img src="' + GEtImage + '">' + "<div class='cust_bundle_Detail'>" + "<div class='cust_bundle_TiTle'>" + GetTitle + "</div>" + "<div class='cust_Prie_Qty'>" + "<div class='cust_bundle_price'>"+ GetPrice + "</div>" +" x "+ "<div class='cust_bundle_qty'>" + "1" + "</div>"  + "</div>" +"<div class='cust_bundle_ID'>"+getID +"</div>" + "<div class='cust_tag_ID'>"+GeTTAg +"</div>" + "</div>" );
      //alert("not contain!");
     } 
   } 
   
  else{
    alert("You can not add more then Four products.");
    }
 }

/*end pocket-squares-pocket-squares-stoles-cufflinks*/    

     /*create session for store values */
     
// var GET_HTML = $('.cust-count-div').html();
// //console.log("GET_HTML " + GET_HTML);
// sessionStorage.setItem("sethtml",GET_HTML);


// var getCollHTml = $(".cust_four_pro").html();  
//      console.log("getCollHTml " + getCollHTml);
// sessionStorage.setItem("collhtml",getCollHTml);
 /*end create session for store values */
     
     
 });



  
/* Bundle add to cart */

$('body').on('click', '.cust_popup_addCart', function(){
// console.log("click adddd to cart");
 var GEtQTY = $("#cust_Quantity").val();
 for(var index = 0; index < IDs.length; index++){ 
  var tsss = IDs[index];
   console.log("tsss " + tsss);
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data:{
      quantity: GEtQTY,
       id: tsss,
     },
    dataType: 'json',
    async:false,
    success: function(response){
     // console.log(response);
      window.location = "/cart";
    }
  });
  };
});
 /* End Bundle add to cart */
  

/* product remove from Div */
     
   $('body').on('click', '.remove_text', function() {
   //console.log("custom remove");
    $(".CUStom_count").children('li:last-child').remove();
    var countmin = count--;
    $(this).text('Add to Cart');
    $(this).removeClass('remove_text');
    $(this).addClass('cust_cart_btn');

    //console.log("IDs " + IDs);

    var removeid = $(this).prev(".cust_Main_proID").text();
   // console.log("removeid " + removeid);

    var Removetag = $(this).parent(".outer_addToCArt").prev(".collection-product-title").children("a").attr("data-tag");
     console.log("Removetag " + Removetag);
      //$(this).prev(".cust_Main_proID").prev(".cust_inventory").prev().addClass('amar');

    for(var index = 0; index < IDs.length; index++) {
     var tsssaaa = IDs[index]; 
      //console.log("tsssaaa " + tsssaaa);
      if(tsssaaa == removeid ){
      //console.log("Matched Ids");
       IDs.splice(index, 1);
      }
    }

    for(var i = 0; i < finalTitles.length; i++) {
     var GEtALLTag = finalTitles[i]; 
      console.log("GEtALLTag " + GEtALLTag);
      if(GEtALLTag == Removetag ){
      console.log("Matched tags");
       finalTitles.splice(i, 1);
      }
      else{
        console.log("Tags not matched");
      }
    }

     console.log("finalTitles " + finalTitles);
     
      $(".cust_pop_info").each(function(){
      var GetRemoveIDS = $(this).children("img").next(".cust_bundle_Detail").children(".cust_bundle_TiTle").next(".cust_Prie_Qty").next(".cust_bundle_ID").text();
     // console.log("GetRemoveIDS " + GetRemoveIDS);

       
      // $(this).prev(".cust_Main_proID").prev(".product-tile").parent(".cust_four_pro").parent(".collection__products").parent(".w-70-l").parent(".flex").next(".cust-count-div").children(".CUStom_count").next(".cust-bbuy-text").next(".cust_main").children(".cust-count").children(".cust_pop_info").children(".cust_bundle_Detail").children(".cust_bundle_ID").text();
      //console.log("removeid "+ removeid); 
      if(GetRemoveIDS == removeid ){
        $(this).remove();
      }
      else{//console.log("not matched");
      }
      });
    });  
     /* end product remove from Div */

  /* get session value */
// if (sessionStorage.getItem("sethtml")) {
//    let storedPw = sessionStorage.getItem("sethtml");
//    $(".cust-count-div").html(storedPw);
//     //console.log("storedPw " + storedPw); 
// }   
    /* end get session value */
}); 




                  